import React from "react";
import Cleave from "cleave.js/react";
import { InputBaseComponentProps } from "@material-ui/core/InputBase";

export default function PhoneNumberInput(props: InputBaseComponentProps) {
  const { options, inputRef, ...other } = props;

  return (
    <Cleave
      {...other}
      htmlRef={(ref: any) => {
        if (inputRef) {
          if (typeof inputRef === 'function') {
            inputRef(ref);
          } else {
            (inputRef as any).current = ref;
          }
        }
      }}
      options={{
        numericOnly: true,
        blocks: [0, 3, 3, 4],
        delimiters: ["(", ") ", "-"]
      }}
    />
  );
}
